var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartsAddToMyAnalog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.770103 0H13.0917C13.5171 0 13.8618 0.34479 13.8618 0.770103V15.6148C13.8618 15.8275 13.6894 16 13.4768 16C13.4227 16 13.3693 15.9885 13.3199 15.9665L6.93092 13.4336L0.541944 15.9665C0.34774 16.0532 0.120067 15.9659 0.0334148 15.7718C0.0113821 15.7223 0 15.6689 0 15.6148V0.770103C0 0.34479 0.34479 0 0.770103 0ZM12 13V2H2V13L6.93092 11.4292L12 13Z",
    fill: "#212836"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4L8 4V10H6V4Z",
    fill: "#212836"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6V8H4V6H10Z",
    fill: "#212836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartsAddToMyAnalog);
export default __webpack_public_path__ + "static/media/parts_add_to_My_analog.c381904b2d7a72b513fae10ef667c56a.svg";
export { ForwardRef as ReactComponent };